import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./TabBar.module.css";
import classNames from "classnames";

/**
 * Tab bar used to change between different tabs at the top of a page
 */
export function TabBar({ titleList, activeTitle, onChange }) {
  const [activeTitleLocal, setActiveTitleLocal] = useState(activeTitle);

  function oncChangeLocal(title) {
    setActiveTitleLocal(title);
    onChange(title);
  }

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        {titleList.map((item, key) => (
          <div
            key={key}
            className={classNames(
              styles.tab,
              item == activeTitleLocal && styles.activeTab
            )}
            onClick={() => oncChangeLocal(item)}
          >
            {item}
            <div
              className={classNames(
                styles.hr,
                item == activeTitleLocal && styles.thickLine
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

TabBar.propTypes = {
  titleList: PropTypes.arrayOf(PropTypes.string),
  activeTitle: PropTypes.string,
  onChange: PropTypes.func,
};
